import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import usePortfolioStore from '../store/portfolioStore.js';

export default function Testimonials() {
  const { testimonials } = usePortfolioStore();
  const seed = testimonials.length ? testimonials : [
    { id: 1, author: 'Client (LinkedIn Services)', role: 'Founder / CEO', text: 'Mesum delivers exceptional results across full-stack and e‑commerce projects. Highly communicative and outcome‑focused.' }
  ];
  return (
    <Box>
      <Typography variant="h5" gutterBottom>Testimonials</Typography>
      <Grid container spacing={2}>
        {seed.map(t => (
          <Grid key={t.id} item xs={12} md={6}>
            <Card className="glass">
              <CardContent>
                <Typography variant="subtitle1" gutterBottom>“{t.text}”</Typography>
                <Typography variant="body2" sx={{ opacity: .8 }}>— {t.author}, {t.role}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}


